import Grid from "@mui/material/Grid";
import { useCallback, useEffect, useState } from "react";
import { ImageCropper } from "../ImageCropper";
import { Image } from "@aws-amplify/ui-react";
import Button from "@mui/material/Button";
import {
  Box,
  colors,
  Stack,
  Typography,
} from "@mui/material";
import { useModal } from "mui-modal-provider";
import TrimmingModal from "../Dialog/TrimmingModal";
import {
  ResourceOperation,
  useApplicationStore,
} from "../../context/ApplicationStoreContext";
import { uploadImage2S3 } from "../../util/Storage";

const ImageSelecter = () => {
  const [uploadImage, setUploadImage] = useState<File>();
  const [uploadImageSrc, setUploadImageSrc] = useState<string>();
  //const [canShowDialog, setCanShowDialog] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const { showModal } = useModal();
  const { state, dispatch } = useApplicationStore();

  const TrimmingModalHandler = (src: string) => {
    const modal = showModal(TrimmingModal, {
      title: "アップロード画像の編集",
      uploadImage: src,
      onConfirm: (blob: Blob) => {
        registCroppedImageHandler(blob)
        modal.hide();
      },
      onCancel: () => {
        modal.hide();
      },
    });
  };

  const fileReaderHandler = (event: ProgressEvent<FileReader>) => {
    setUploadImageSrc(event.target?.result as string);
    TrimmingModalHandler(event.target?.result as string);
    setHasError(false)
  };

  const imageSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files![0]) return;
    const fileData = new FileReader();
    fileData.onloadend = fileReaderHandler;
    setUploadImage(event.target.files![0]);
    fileData.readAsDataURL(event.target.files![0]);
  };

  const nextHandler = async() => {
    console.log(state.uploadImage);
    if (state.uploadImage !== null) {
      //await uploadImage2S3(state.uploadImage);
      dispatch({ type: ResourceOperation.ADD_INDEX });
    } else {
      setHasError(true)
    }
  };

  const registCroppedImageHandler=(blob:Blob)=>{
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      setUploadImageSrc(reader.result as string);
    };
  }

  useEffect(()=>{
    if(state.uploadImage !==null) registCroppedImageHandler(state.uploadImage.blob!)
  },[state.uploadImage])

  return (
    <Stack spacing={1.5}>
      <Box>
        {!uploadImageSrc ? null : (
          <Image
            src={uploadImageSrc}
            alt="selected_image"
            width="100%"
            borderRadius="50%"
          />
        )}
      </Box>
      <Box>
        <input
          type="file"
          accept="image/*"
          onChange={imageSelectedHandler}
          id="raised-button-file"
          style={{ display: "none" }}
        />
        <label htmlFor="raised-button-file">
          <Button variant="outlined" component="span">画像を選択する。</Button>
        </label>
      </Box>
      {hasError ? (
        <Typography variant="caption" display="block" color={colors.red[400]}>
          画像の選択は必須です。
        </Typography>
      ) : null}
      <Box sx={{ mb: 2 }}>
        <div>
          <Button
            variant="contained"
            onClick={nextHandler}
            sx={{ mt: 1, mr: 1 }}
          >
            次へ
          </Button>
        </div>
      </Box>
    </Stack>
  );
};

export default ImageSelecter;
